import styled from 'styled-components';
import MaterialIcon from './MaterialIcon';

const ActionIcon = styled(MaterialIcon)`
    vertical-align: middle;
    user-select: none;
    &:hover{
        cursor: pointer;
        transform: translateY(-1px);
    }
`;

export default ActionIcon